// assets/cart-popup.js
(() => {
  // ====== CONFIG ======
  // For testing, keep this low (e.g., 8000 = 8 seconds)
  const DELAY_MS = 8000; // change to 60000 for 60s in production
  const STORAGE_KEY = 'unilab_cart_popup_shown';

  let popupTimer = null;
  let checkoutStarted = false;

  // ====== HELPERS ======
  const popupAlreadyShown = () => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  };

  const markPopupShown = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
  };

  const markCheckoutStarted = () => {
    checkoutStarted = true;
    if (popupTimer) {
      clearTimeout(popupTimer);
      popupTimer = null;
    }
  };

  const startPopupTimer = () => {
    // While testing on mobile, you can temporarily comment out popupAlreadyShown()
    if (popupTimer || checkoutStarted || popupAlreadyShown()) return;

    popupTimer = window.setTimeout(() => {
      popupTimer = null;
      if (!checkoutStarted) {
        showCartPopup();
        markPopupShown();
      }
    }, DELAY_MS);
  };

  // ====== POPUP UI (semi-translucent) ======
  const showCartPopup = () => {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.background = 'rgba(0, 0, 0, 0.45)';
    overlay.style.zIndex = '9999';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.backdropFilter = 'blur(3px)';
    overlay.style.webkitBackdropFilter = 'blur(3px)';

    // lock background scroll (important on mobile)
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const box = document.createElement('div');
    box.style.background = 'rgba(255,255,255,0.80)';
    box.style.backdropFilter = 'blur(8px)';
    box.style.webkitBackdropFilter = 'blur(8px)';
    box.style.padding = '28px 24px';
    box.style.maxWidth = '420px';
    box.style.width = '90%';
    box.style.borderRadius = '12px';
    box.style.boxShadow = '0 8px 32px rgba(0,0,0,0.20)';
    box.style.textAlign = 'center';
    box.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

    box.innerHTML = `
      <h2 style="margin:0 0 12px; font-size:20px; font-weight:700; color:#000;">
        Hi! Your health journey is just one click away!
      </h2>

      <p style="margin:0 0 20px; font-size:14px; line-height:1.5; color:#333;">
        Your tests are still waiting in your cart. Finish checking out when you're ready.
      </p>

      <button
        id="unilab-popup-go-to-cart"
        style="
          display:inline-block;
          margin:0 6px 8px 0;
          padding:10px 20px;
          font-size:14px;
          font-weight:600;
          border-radius:6px;
          border:none;
          cursor:pointer;
          background:#4682B4;
          color:#ffffff;
        ">
        Go to my cart
      </button>

      <button
        id="unilab-popup-close"
        style="
          display:inline-block;
          margin:0 0 0 6px;
          padding:10px 20px;
          font-size:14px;
          border-radius:6px;
          border:1px solid rgba(0,0,0,0.2);
          background:rgba(255,255,255,0.6);
          cursor:pointer;
        ">
        Not now
      </button>
   `;

    overlay.appendChild(box);
    document.body.appendChild(overlay);

    const closePopup = () => {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.style.overflow = previousOverflow;
    };

    document.getElementById('unilab-popup-close')?.addEventListener('click', closePopup);
    document.getElementById('unilab-popup-go-to-cart')?.addEventListener('click', () => {
      closePopup();
      window.location.href = '/cart';
    });
  };

  // ====== CHECKOUT DETECTION ======

  // If already on checkout, mark it
  if (window.location.pathname.startsWith('/checkout')) {
    markCheckoutStarted();
  }

  const checkoutClickHandler = (event) => {
    const target = event.target.closest('button, a, input[type="submit"]');
    if (!target) return;

    const href = target.getAttribute('href') || '';
    const text = ((target.innerText || target.value) || '').toLowerCase();

    if (
      href.startsWith('/checkout') ||
      text.includes('checkout') ||
      text.includes('buy it now') ||
      target.name === 'checkout'
    ) {
      markCheckoutStarted();
    }
  };

  document.addEventListener('click', checkoutClickHandler);
  document.addEventListener('touchstart', checkoutClickHandler);

  // ====== ADD-TO-CART DETECTION (MOBILE + DESKTOP) ======

  // 1) Classic form submit to /cart/add
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    if (action.includes('/cart/add')) {
      startPopupTimer();
    }
  });

  // 2) Intercept fetch /cart/add.js (covers Dawn AJAX add-to-cart)
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';

      if (url && url.includes('/cart/add')) {
        Promise.resolve().then(startPopupTimer);
      }

      return originalFetch.apply(this, args);
    };
  }

  // 3) If Dawn fires a custom cart event
  document.addEventListener('cart:refresh', () => {
    startPopupTimer();
  });
})();
